/* Mockup v3 P9 "Latencia y errores por modelo y paso" (v3 `:1916`): a card head with two selects,
   the table, and the help line under it. */
.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-4);
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.titles {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-1);
  min-inline-size: 200px;
}

.title {
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.meta {
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  color: var(--text-muted);
  font-size: var(--font-size-12);
}

.select {
  min-block-size: 32px;
  padding-inline: var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font: inherit;
  font-size: var(--font-size-13);
}

.wrap {
  overflow-x: auto;
}

.table {
  inline-size: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
}

.table th,
.table td {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  text-align: start;
  white-space: nowrap;
}

.table thead th {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
}

.number {
  font-variant-numeric: tabular-nums;
  text-align: end;
}

.badge {
  display: inline-block;
  padding: 0 var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-pill);
  font-size: var(--font-size-12);
}

.mono {
  font-family: var(--font-mono);
  font-size: var(--font-size-12);
}

.rateBad {
  color: var(--danger-text);
  font-weight: var(--font-weight-semibold);
}

.help {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
